import {useMutation, useQueryClient} from "@tanstack/react-query";
import {createEditEvent} from "../services/apiEvents.js";


export function useEditEvent() {
    const queryClient = useQueryClient();
    const {mutate: editEvent, isLoading: isEditing} = useMutation({
        mutationFn: ({newCabinData, id}) => createEditEvent(newCabinData, id),
        onSuccess: () => {
            alert("Event edited successfully");
            queryClient.invalidateQueries({
                queryKey: ["events"],
            });
        },
        onError: (error) => {
            console.error("Error creating event:", error);
            alert("Error creating event: " + error.message);
        },
    })
    
    return {isEditing, editEvent};
}
